module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "p01"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "width-10"
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "002",
      "src": "Images/clau_9780738214993_oeb_002_r1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ct"
  }, [_vm._v("\n    PART I\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "cst"
  }, [_vm._v("\n    DUALITY\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "au"
  }, [_vm._v("\n    YIN, YANG, AND HORMONES\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "pepiv"
  }, [_c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v("Foolish the doctor who despises the knowledge acquired by the ancients.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "peps"
  }, [_vm._v("\n    —HIPPOCRATES,THE FATHER OF WESTERN MEDICINE\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("A")]), _vm._v("LTHOUGH EASTERN MEDICINE DOESN’T NAME AND EXPLAIN INDIVIDUAL HORMONES, IT GIVES US A COMPREHENSIVE CONTEXT IN WHICH TO UNDERSTAND HOW THEY WORK. IT IS AN EMINENTLY PRACTICAL AND USEFUL PERSPECTIVE THAT EXPLAINS THE FUNDAMENTAL CAUSES OF HORMONAL IMBALANCE AND THE REMEDIES FOR RESTORING IT. RATHER THAN LEARNING HOW TO MANIPULATE EACH AND EVERY HORMONE, WE WILL SIMPLY OPTIMIZE THEIR ENVIRONMENT THROUGH CHANGES IN NUTRITION AND LIFESTYLE, AND OUR HORMONES WILL SHIFT IN RESPONSE.\n  ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f8b842d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/clau_9780738214993_oeb_p01_r1.vue
// module id = 81
// module chunks = 0